import { KText } from '@/ui-library/components/text';
import React from 'react';
import { components } from 'react-select';

export const SelectWithAdditionalLabel = (props) => {
  const { data, selectProps = {} } = props;
  const { extraProps = {} } = selectProps;
  const { labelKey = 'label', additionalLabelKey = 'additionalLabel' } =
    extraProps;
  const label = data?.[labelKey];
  const additionalLabel = data?.[additionalLabelKey];

  return (
    <components.Option {...props}>
      <KText>
        {label}
        {additionalLabel && (
          <KText ml="15px" as="span" color="secondary-800">
            - {additionalLabel}
          </KText>
        )}{' '}
      </KText>
    </components.Option>
  );
};
